import Client from "../Client";

const AllTabsCollection = [
    {
        id: "dashboard",
        icon: "dashboard",
        title: "Dashboard",
        route: "/dashboard/sameday",
    },
    {
        id: "forms",
        icon: "notes",
        title: "Forms",
        // route: "/forms",

        roles: [ "admin", "province", "lgu", "reviewer" ],

        subtabs: [
            {
                id: "sameday",
                title: "Same Day",
                route: "/forms/sameday",
            },
            // { 
            //     id: "overnight",
            //     title: "Overnight",
            //     route: "/forms/overnight",
            // },
        ]
    },
    {
        id: "reports",
        icon: "notes",
        title: "Reports",
        roles: [ "admin", "province", "lgu", "reviewer" ],
        // route: "/reports",

        subtabs: [
            {
                id: "sameday",
                title: "Same Day",
                route: "/reports/sameday",
            },
            // { 
            //     id: "overnight",
            //     title: "Overnight",
            //     route: "/reports/overnight",
            // },
        ]
    },
    // {
    //     id: "submissions",
    //     icon: "notes",
    //     title: "Submissions",
    //     route: "/submissions",

    //     roles: [ "admin", "province", "lgu", "reviewer" ],

    //     subtabs: [
    //         {
    //             id: "sameday",
    //             title: "Same Day",
    //             route: "/submissions/sameday",
    //         },
    //         { 
    //             id: "overnight",
    //             title: "Overnight",
    //             route: "/submissions/overnight",
    //         },
    //     ]
    // },
    {
        id: "attractions",
        icon: "location",
        roles: [ "admin" ],
        title: "Attractions",
        route: "/attractions"
    },
    {
        id: "accounts",
        icon: "person",
        roles: [ "admin" ],
        title: "Accounts",
        route: "/accounts"
    },
    // {
    //     id: "test",
    //     icon: "add",
    //     title: "Test",
    //     route: "/test"
    // },
];

/**
 * @typedef {{ id: string, icon: string, title: string, roles: string[], route: string, subtabs: TabOptions[] }} TabOptions
 */

export const Tabs = {
    /** @type {TabOptions[]} */
    all: [],

    initialize() {
        // Client.ensureSignedIn();

        const account = Client.account;
        const tabs = AllTabsCollection.filter(
            t => !t.roles || t.roles.includes(account.role));

        this.all = tabs;
    }
};